import { VSpacing } from '@hh.ru/magritte-ui';

import paths from 'src/app/routePaths';
import CatalogLinksList from 'src/components/CatalogSearch/CatalogLinksList';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const RelatedSearches = ({ trls }) => {
    const queries = useSelector((state) => state.vacancySearchResult.queryRanks);

    if (queries.length === 0) {
        return null;
    }

    const links = queries.map(({ q2, href }) => ({
        title: capitalizeFirstLetter(q2),
        path: `${paths.vacancySearch}?${href}&from=SIMILAR_QUERY&hhtmFromLabel=SIMILAR_QUERY`,
    }));

    return (
        <>
            <VSpacing default={40} />
            <CatalogLinksList links={links} title={trls[RelatedSearches.trls.header]} />
        </>
    );
};

RelatedSearches.trls = {
    header: 'search.vacancies.relatedSearch',
};

export default translation(RelatedSearches);
